import { useCallback, useState } from 'react';

const read = (key, fallback) => {
  try {
    const value = window.localStorage.getItem(key);
    return value === null ? fallback : value === '1';
  } catch {
    return fallback;
  }
};

/**
 * An open/closed choice remembered for this viewer in this browser (a disclosure on Home, say). Storage can be missing
 * or blocked (a private window, a preview): then it simply starts from `initial` every time.
 */
export default function useRememberedToggle(key, initial = false) {
  const [open, setOpen] = useState(() => read(key, initial));
  const toggle = useCallback(() => {
    setOpen((current) => {
      const next = !current;
      try { window.localStorage.setItem(key, next ? '1' : '0'); } catch { /* not remembered, still toggles */ }
      return next;
    });
  }, [key]);
  return [open, toggle];
}
